"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  FORMS: {
    INVALID_EMAIL_ERROR: 'This email address does not appear to be valid'
  },
  CONTACT_PROPERTIES: {
    PROPERTY_LIMIT_REACHED: 'propertyLimitReached',
    UNKNOWN_ERROR: 'unknownError'
  }
};
exports.default = _default;
module.exports = exports.default;